import Swiper, { Navigation, Pagination } from 'swiper';

/**
 * @function CardsB1
 * @author Dreamers of Day
 * @description Initializes Swiper sliders for modules marked with `data-module="cardsB1"` using navigation and pagination.
 * Adds accessibility-related styling to navigation arrows based on progress state.
 * This function should be invoked once the DOM is ready.
 *
 * @returns {void}
 */
function CardsB1() {
    // Register Swiper modules: Navigation and Pagination
    Swiper.use([Navigation, Pagination]);

    // Loop over each module in the DOM marked with data-module="cardsB1"
    $('[data-module="cardsB1"]').each(function () {
        // Reference to the current module element
        const module = $(this);

        // Instantiate a new Swiper instance targeting the first `[data-slider]` inside the module
        const swiper = new Swiper(module.find('[data-slider]')[0], {
            loop: true, // Enables continuous loop mode
            slidesPerView: 'auto', // Allows variable width slides
            spaceBetween: 16, // Space in px between slides on smaller breakpoints
            noSwipingSelector: 'a', // Prevent swipe behavior on anchor elements

            // Responsive breakpoints configuration
            breakpoints: {
                1024: {
                    spaceBetween: 24, // Increase space between slides on wider screens
                },
            },

            // Swiper navigation arrows
            navigation: {
                prevEl: module.find('.js-slider-prev')[0], // Previous arrow
                nextEl: module.find('.js-slider-next')[0], // Next arrow
            },

            // Pagination indicator setup
            pagination: {
                el: module.find('.swiper-pagination')[0], // Target pagination element
                type: 'progressbar', // Use progress bar type indicator
            },
        });

        // Bind event to update arrow states based on progress
        swiper.on('progress', function (_swiperInstance, progress) {
            // If progress is at or before the beginning, disable the "prev" button
            if (progress <= 0) {
                module
                    .find('.js-slider-prev')
                    .addClass('a-btn-pagination--disabled');
            } else {
                // Otherwise, enable it
                module
                    .find('.js-slider-prev')
                    .removeClass('a-btn-pagination--disabled');
            }

            // If progress is at or past the end, disable the "next" button
            if (progress >= 1) {
                module
                    .find('.js-slider-next')
                    .addClass('a-btn-pagination--disabled');
            } else {
                // Otherwise, enable it
                module
                    .find('.js-slider-next')
                    .removeClass('a-btn-pagination--disabled');
            }
        });

        // Immediately disable prev arrow if we're at the start
        if (swiper.isBeginning) {
            module
                .find('.js-slider-prev')
                .addClass('a-btn-pagination--disabled');
        }

        // Immediately disable next arrow if we're at the end
        if (swiper.isEnd) {
            module
                .find('.js-slider-next')
                .addClass('a-btn-pagination--disabled');
        }
    });
}

// Export the initialized function for use elsewhere
export default CardsB1;
